import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useCheckPermission from '../../utils/permissions/useCheckPermissions';
import { PermissionsProvider } from '../../utils/permissions/PermissionsContext';
import SystemRoles from './SystemUsers/SystemRoles';
import SystemUsers from './SystemUsers/SystemUsers';
import SystemSettings from './SystemUsers/SystemSettings';
import SystemMessages from './SystemUsers/SystemMessages';
import SystemVersions from './SystemUsers/SystemVersions';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`admin-tabpanel-${index}`}
            aria-labelledby={`admin-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `admin-tab-${index}`,
        'aria-controls': `admin-tabpanel-${index}`,
    };
}

const AdminTabs = () => {
    const isSuper = useCheckPermission('super');
    const { t } = useTranslation();
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <PermissionsProvider>
            <div>
                <Box
                    sx={{
                        borderBottom: 1,
                        borderColor: 'divider',
                        paddingTop: 0,
                    }}
                >
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="admin tabs"
                        variant="fullWidth"
                    >
                        <Tab
                            label={t('systemAdmin.tabs.users')}
                            {...a11yProps(0)}
                        />
                        {isSuper && (
                            <Tab
                                label={t('systemAdmin.tabs.roles')}
                                {...a11yProps(1)}
                            />
                        )}
                        {isSuper && (
                            <Tab label="Системни Съобщения" {...a11yProps(2)} />
                        )}
                        {isSuper && (
                            <Tab label="Versions Control" {...a11yProps(3)} />
                        )}
                        {isSuper && (
                            <Tab
                                label={t('systemAdmin.tabs.settings')}
                                {...a11yProps(isSuper ? 4 : 2)}
                            />
                        )}
                    </Tabs>
                </Box>
                <TabPanel value={value} index={0}>
                    <SystemUsers />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <SystemRoles />
                </TabPanel>
                <TabPanel value={value} index={isSuper ? 4 : 2} padding={10}>
                    <SystemSettings />
                </TabPanel>
                {isSuper && (
                    <TabPanel value={value} index={2} padding={10}>
                        <SystemMessages />
                    </TabPanel>
                )}
                {isSuper && (
                    <TabPanel value={value} index={3} padding={10}>
                        <SystemVersions />
                    </TabPanel>
                )}
            </div>
        </PermissionsProvider>
    );
};

export default AdminTabs;
